"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableHeadCell = _interopRequireDefault(require("./TableHeadCell.style"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _excluded = ["accessor", "children", "sortable", "sortDirection", "clickAction"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var sortDirections = ['asc', 'desc', 'default'];
var TableHeadCell = function TableHeadCell(_ref) {
  var accessor = _ref.accessor,
    children = _ref.children,
    sortable = _ref.sortable,
    sortDirection = _ref.sortDirection,
    clickAction = _ref.clickAction,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var nextDirectionMapping = {};
  for (var i = 0; i < sortDirections.length - 1; i += 1) {
    nextDirectionMapping[sortDirections[i]] = sortDirections[i + 1];
  }
  nextDirectionMapping[sortDirections[sortDirections.length - 1]] = sortDirections[0];
  var handleClick = function handleClick() {
    clickAction(accessor, nextDirectionMapping[sortDirection]);
  };
  var clickProperties = typeof clickAction === 'function' && sortable ? {
    onClick: handleClick,
    onKeyDown: handleClick,
    role: 'link',
    tabIndex: '0'
  } : {};
  return /*#__PURE__*/_react["default"].createElement(_TableHeadCell["default"], _extends({
    sortable: sortable
  }, clickProperties, otherProps), children, sortable && /*#__PURE__*/_react["default"].createElement("span", {
    className: "sort-icons"
  }, sortDirection === 'asc' && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-arrow-dropup"
  }), sortDirection === 'desc' && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-arrow-dropdown"
  }), sortDirection === 'default' && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-arrow-dropup"
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-arrow-dropdown"
  }))));
};
TableHeadCell.propTypes = {
  /** The alignment of the table text */
  align: _propTypes["default"].oneOf(['right', 'left', 'center']),
  /**
   * The api name for this field (used for sorting)
   * */
  accessor: _propTypes["default"].oneOfType([_propTypes["default"].shape({}), _propTypes["default"].string]),
  /**
   * The content of the table cell, normally a node or a string.
   * */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  /**
   * Callback fired when the column is clicked (Usually used for sorting)
   *
   * @param {string} accessor The api field name for which the sort is done.
   * @param {string} direction The direction for the sorting (asc, desc)
   *
   * */
  clickAction: _propTypes["default"].func,
  /**
   * Flag to indicate wheather the column is sortable.
   * */
  sortable: _propTypes["default"].bool,
  /**
   * The sorting direction of the column in case sortable is true.
   * */
  sortDirection: _propTypes["default"].oneOf(sortDirections)
};
TableHeadCell.defaultProps = {
  align: 'left',
  accessor: '',
  children: '',
  clickAction: undefined,
  sortable: false,
  sortDirection: 'default'
};
var _default = exports["default"] = TableHeadCell;